import React, {
  useState,
  ChangeEvent,
  useMemo,
  useRef,
  useEffect,
} from "react";
import Header from "../../../components/header";
import Inputs from "../../../components/inputs";
import "./createTemplate.css";
import { Formik, ErrorMessage, FormikProps } from "formik";
import { Button, Spin } from "antd";
import { styled } from "styled-components";
import { createTemplate, getTemplateById, updateTemplate } from "../../../services/templates";
import { toast } from "react-hot-toast";
import { upperCase } from "lodash";
import MyToolTip from "../../../components/MyToolTip";
import DrawerExistModal from "../../../components/drawerExistModal";
import { languageObj } from "../../../components/common";
import { useSelector } from "react-redux";
import { uploadMedia } from "../../../services/whatsapp";
import BodySection from "./bodySection";
import ButtonSection from "./buttonSection/buttonSection";
import HeaderSection from "./headerSection/headerSection";
import WhatsAppPreview from "./WhatsAppPreview";
import TemplateMetrics from "./TemplateMetrics";
import { validateButtonGrouping } from "./buttonSection/types";
import logger from "../../../utils/logger";
import { trackEvent } from "../../../config/firebase";

const isValidUrl = (url: string): boolean => {
  const urlPattern = /^(https?:\/\/)?([\w-]+\.)+[\w-]+(\/[\w-./?%&=]*)?$/;
  return urlPattern.test(url);
};

// Convert numbered variables back to named variables for editing
const convertNumberedToNamedVariables = (text: string, mapper: { [key: string]: string }): string => {
  if (!mapper || !text) return text;
  
  logger.log('Converting:', text, 'with mapper:', mapper);
  
  const result = text.replace(/\{\{(\d+)\}\}/g, (match, number) => {
    const fieldName = mapper[number];
    logger.log(`Converting ${match} (${number}) -> ${fieldName ? `{{${fieldName}}}` : match}`);
    return fieldName ? `{{${fieldName}}}` : match;
  });
  
  logger.log('Result:', result);
  return result;
};

interface ExpandedSections {
  [key: string]: boolean;
}
interface TeamMember {
  value: string;
  label: string;
  type: string;
}
interface Props {
  toggleCreate: (value: string) => void;
  editTemplateData: any;
}
interface TemplateFormValue {
  name?: string;
  category?: string;
  language?: string;
  header?: string;
  header_value?: string;
  body?: string;
  buttons?: any[];
  footer?: string;
}

let typeValues = {
  name: "Vivek rana",
  phone: "+91 7015823248",
  email: "vivek@3sigmacrm.com",
  notes: "this is a sample note",
  text: "dummy text",
  number: "01274894949",
  amount: "848848",
  address: "212,central dekhi second flow, 202,122003 Gurgaon haryana",
  option: "option 1",
  selection: "option 1, option 2",
  date: "24 August 2023 5,30 pm",
  time: "16:32",
};

const defaultButton = {
  type: "",
  text: "",
  url: "",
  phone_number: ""
}

const CreateTemplate: React.FC<Props> = ({
  toggleCreate,
  editTemplateData,
}) => {
  const formikRef = useRef<FormikProps<any>>(null);

  const [disabled, setDisabled] = useState<boolean>(false);
  const [value, setValue] = useState<string>("");
  const [bodyValue, setBodyValue] = useState<string>(
    editTemplateData?.components
      ?.find((item: any) => item.type === "BODY")
      ?.text?.replace(/\{\{(\d+)\}\}/g, (_: any, i: string) => {
        return editTemplateData?.mapper?.[i] ?? "";
      }) ?? ""
  );


useEffect(() => {
  if (editTemplateData?.components) {
    const headerDoc = editTemplateData.components.find(
      (c: { type: string; format: string }) =>
        c.type === "HEADER" && ["DOCUMENT", "IMAGE", "VIDEO"].includes(c.format)
    );
    if (headerDoc?.example?.header_handle?.[0]) {
      // ✅ Extract real filename from filePaths
      const realFileName = editTemplateData.filePaths?.[0]?.split('/').pop() || "document.pdf";
      logger.log("📄 Setting filename:", realFileName);
      setFileName(realFileName);
    }
  }
}, [editTemplateData]);

  const [fileName, setFileName] = useState<string>("");
  const [showExitModal, setShowExitModal] = useState<boolean>(false);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
 
  
  const [templateAnalytics, setTemplateAnalytics] = useState<any>(null);
const [loadingAnalytics, setLoadingAnalytics] = useState<boolean>(false);

  const [confirmShowExitModal, setConfirmShowExitModal] =
    useState<boolean>(false);
  // const [assignLeadDrawer, setAssignLeadDrawer] = useState(false);
  const [formValue, setFormValue] = useState<TemplateFormValue>({});
  const [expandedSections, setExpandedSections] = useState<ExpandedSections>({
    section1: true,
    section2: true,
    section3: true,
  });

  const [file, setFile] = useState<any>(null);
  const [isError, setIsError] = useState<boolean>(false);

  const StateData = useSelector((state: any) => {
    return state?.rootReducers;
  });
  const handleSetFieldValue = (field: string, value: any) => {
    if (formikRef.current) {
      formikRef.current.setFieldValue(field, value);
    }
  };

  const teamMembers: TeamMember[] =
    StateData?.userData?.userDetails?.userPreference?.customForm?.map(
      (item: any) => {
        return {
          value: item?.value,
          label: item?.name,
          type: item?.type,
        };
      }
    ) || [];

    useEffect(() => {
      if (editTemplateData?._id) {
        setLoadingAnalytics(true);
        getTemplateById(editTemplateData._id)
          .then((response) => {
            if (response?.data?.data?.whatsappTemplateAnalytics) {
              setTemplateAnalytics(response.data.data.whatsappTemplateAnalytics);
            }
            setLoadingAnalytics(false);
          })
          .catch((error) => {
            logger.error("Error fetching template analytics:", error);
            setLoadingAnalytics(false);
          });
      }
    }, [editTemplateData]);

  useEffect(() => {
    if (formikRef?.current) {
      setIsError(!!Object.keys(formikRef.current?.errors)?.length || false);
    }
  }, [formikRef?.current]);

  useEffect(() => {
    if (formikRef?.current?.values?.header_value && !file && formikRef?.current?.values?.header !== "text") {
      formikRef?.current?.setFieldValue("header_value", "");
      setFileName("");
    }
  }, [file]);

  const toggleSection = (sectionId: string) => {
    setExpandedSections((prevState) => ({
      ...prevState,
      [sectionId]: !prevState[sectionId],
    }));
  };

  const handleFileChange = (event: ChangeEvent<HTMLInputElement>) => {
    const file: any = event.target.files?.[0];
    if (file) {
      // Format filename: remove spaces and special characters, keep extension
      const nameWithoutExt = file.name.substring(0, file.name.lastIndexOf('.')) || file.name;
      const extension = file.name.substring(file.name.lastIndexOf('.')) || '';

      const formattedName = nameWithoutExt
        .toLowerCase()
        .replace(/[^a-z0-9_]/g, '_')  // Replace any non-alphanumeric/underscore with underscore
        .replace(/_+/g, '_')          // Replace multiple consecutive underscores with single
        .replace(/^_|_$/g, '');       // Remove leading/trailing underscores

      const finalFileName = formattedName + extension;
      setFileName(finalFileName);

      // Create a new File object with the formatted name
      const formattedFile = new File([file], finalFileName, { type: file.type });
      setFile(formattedFile);
    } else {
      setFileName("");
      setFile(null);
    }
  };

  const toggleEditModal = () => {
    setShowExitModal(!showExitModal);
  };
  const toggleConfirmEditModal = () => {
    setConfirmShowExitModal(!confirmShowExitModal);
  };

  const handleDrawerClick = () => {
    setShowExitModal(!showExitModal);
    toggleCreate("");
  };

  // ✅ Helper function to generate generic filenames
const getGenericFileName = (mediaFormat: string): string => {
  logger.log("🎯 Generating generic filename for format:", mediaFormat);
  
  switch(mediaFormat.toUpperCase()) {
    case 'DOCUMENT': return 'document.pdf';
    case 'IMAGE': return 'image.jpg'; 
    case 'VIDEO': return 'video.mp4';
    default: 
      logger.warn("⚠️ Unknown media format:", mediaFormat);
      return 'media';
  }
};

// ✅ Helper function to create placeholder file object for existing media
const createPlaceholderFile = (mediaFormat: string, fileName: string): File | null => {
  try {
    logger.log("🏗️ Creating placeholder file:", { mediaFormat, fileName });
    
    // Create a minimal File-like object for preview consistency
    const mimeType = getMimeType(mediaFormat);
    const blob = new Blob([], { type: mimeType });
    const file = new File([blob], fileName, { type: mimeType });
    
    // ✅ Add a flag to identify this as existing media (not new upload)
    (file as any).isExistingMedia = true;
    (file as any).mediaFormat = mediaFormat;
    
    return file;
  } catch (error) {
    logger.error("❌ Error creating placeholder file:", error);
    return null;
  }
};

// ✅ Helper function to get MIME type from media format
const getMimeType = (mediaFormat: string): string => {
  switch(mediaFormat.toUpperCase()) {
    case 'DOCUMENT': return 'application/pdf';
    case 'IMAGE': return 'image/jpeg'; 
    case 'VIDEO': return 'video/mp4';
    default: return 'application/octet-stream';
  }
};

  const handleConfirmDrawerClick = async () => {
    setConfirmShowExitModal(!confirmShowExitModal);
    setIsSubmitting(true); // Added this line

    // 📊 Track template submission start
    trackEvent("template_submission_started", {
      platform: "web",
      timestamp: new Date().toISOString(),
      is_edit: !!editTemplateData,
      template_name: formValue?.name || "unknown",
      template_category: formValue?.category || "unknown",
      template_language: formValue?.language || "unknown",
      has_header: formValue?.header !== "none",
      header_type: formValue?.header || "none",
      has_buttons: (formValue?.buttons?.length ?? 0) > 0,
      button_count: formValue?.buttons?.length ?? 0,
    });

    try {
      const userIntigrationsList = JSON.parse(
        localStorage.getItem("userData") || ""
      ).userIntegrations;

      const findData = userIntigrationsList.find(
        (item: any) =>
          item?.integration?._id === "646b9286ae8ef73b33caec2e" &&
          item?.isActive
      );

      handler(formValue)
        .then(() => {
          toggleCreate("success");
          toast.success(
            `Template ${editTemplateData ? "update" : "created"} successfully.`
          );

          // 📊 Track successful template submission
          trackEvent("template_submission_completed", {
            platform: "web",
            timestamp: new Date().toISOString(),
            success: true,
            is_edit: !!editTemplateData,
            template_name: formValue?.name || "unknown",
            template_category: formValue?.category || "unknown",
            template_language: formValue?.language || "unknown",
            has_header: formValue?.header !== "none",
            header_type: formValue?.header || "none",
            has_buttons: (formValue?.buttons?.length ?? 0) > 0,
            button_count: formValue?.buttons?.length ?? 0,
          });

          setIsSubmitting(false);
        })
        .catch((error) => {
          setIsSubmitting(false);
          logger.log('🚨 FULL ERROR OBJECT:', error);
          logger.log('🚨 ERROR RESPONSE:', error?.response?.data);

          // 📊 Track template submission error
          trackEvent("template_submission_error", {
            platform: "web",
            timestamp: new Date().toISOString(),
            is_edit: !!editTemplateData,
            template_name: formValue?.name || "unknown",
            error_message: error?.response?.data?.message || error?.message || "Unknown error",
            error_code: error?.response?.status || "unknown",
          });

          toast.error(
            error?.response?.data?.message ??
              `Something went wrong while ${
                editTemplateData ? "updating" : "creating"
              } template`
          );
        });
    } catch (error) {
      setIsSubmitting(false);

      // 📊 Track unexpected error
      trackEvent("template_submission_error", {
        platform: "web",
        timestamp: new Date().toISOString(),
        is_edit: !!editTemplateData,
        stage: "pre_submission",
        error_message: (error as any)?.message || "Unknown error",
      });
    }
  };

  const handler = async (values: any): Promise<any> => {
    const components = [];
    let mapper: { [key: string]: string } = {};
    let headerMapper: { [key: string]: string } = {};
    let filePath: string[] = [];

    // Extract header dynamic fields
    const headerTypes = values.header === "text" && values.header_value
      ? values.header_value
          .match(/{{(.*?)}}/g)
          ?.map((val: any) => val.replace(/{{|}}/g, "")) || []
      : [];

    // Extract body dynamic fields - use the actual body value passed to the function
    const actualBodyText = values.body || "";
    const bodyTypes = actualBodyText
      ? actualBodyText
          .match(/{{(.*?)}}/g)
          ?.map((val: any) => val.replace(/{{|}}/g, "")) || []
      : [];

    // Create separate mappers with independent numbering
    headerTypes.forEach((field: string, index: number) => {
      headerMapper[`${index + 1}`] = field;
    });

    bodyTypes.forEach((field: string, index: number) => {
      mapper[`${index + 1}`] = field;
    });
  
    // Header processing
    if (values.header !== "none") {
      if (file) {
        const formData = new FormData();
        formData.append("files", file);
        formData.append("isTemplateFile", "true");
  
        const response = await uploadMedia(formData);
  
        if (response?.data) {
          components.push({
            type: "HEADER",
            format: upperCase(values.header),
            example: {
              header_handle: [response?.data?.data[0]?.uploadedId],
            },
          });
          filePath = [response?.data?.data[0]?.filePath];
        }
      } else if (values.header === "text" && values.header_value && values.header_value.trim()) {
        // Handle header text with dynamic fields
        if (headerTypes.length > 0) {
          let headerCount = 1;
          components.push({
            type: "HEADER",
            format: "TEXT",
            text: values.header_value.replace(/\{\{.*?\}\}/g, () => `{{${headerCount++}}}`),
            example: {
              header_text: headerTypes.map((type: string) => {
                const teamMember = teamMembers.find(
                  (member: TeamMember) => member.value === type
                );
                return teamMember
                  ? typeValues[teamMember.type as keyof typeof typeValues]
                  : type;
              }),
            },
          });
        } else {
          components.push({
            type: "HEADER",
            format: "TEXT",
            text: values.header_value,
          });
        }
      }
    }
  
    // Body processing - use the merged body value
    const bodyText = values.body || "";
    
    // Debug logging - SIMPLIFIED
    logger.log('🔍 SIMPLE DEBUG:', { hasBody: !!bodyText.trim(), bodyText });
    
    // WhatsApp requires a BODY component for all templates
    if (bodyText.trim()) {
      // bodyTypes already extracted above
      let body_text: string[] = [];
  
      if (bodyTypes.length > 0) {
        body_text = bodyTypes.map((type: string) => {
          const teamMember = teamMembers.find(
            (member: TeamMember) => member.value === type
          );
          return teamMember
            ? typeValues[teamMember.type as keyof typeof typeValues]
            : type;
        });
      } else {
        body_text = [bodyText];
      }
  
      if (bodyText?.match(/{{(.*?)}}/g)?.length) {
        // Body numbering starts from 1 (independent of header)
        let count = 1;
        const bodyComponent = {
          type: "BODY",
          text: bodyText?.replace(/\{\{.*?\}\}/g, () => `{{${count++}}}`),
          example: {
            body_text: body_text,
          },
        };

        logger.log('📝 Creating BODY component with variables:', {
          bodyComponent,
          originalBodyText: bodyText,
          bodyTypes,
          body_text
        });

        logger.log('🔍 DETAILED BODY COMPONENT:', JSON.stringify(bodyComponent, null, 2));

        components.push(bodyComponent);
      } else {
        const bodyComponent = {
          type: "BODY",
          text: bodyText,
        };
        
        logger.log('📝 Creating BODY component without variables:', bodyComponent);
        components.push(bodyComponent);
      }
    } else {
      // Safeguard: If no body text provided, this should be caught by validation
      // but ensure we don't proceed without required BODY component
      throw new globalThis.Error("Body text is required for WhatsApp templates");
    }
  
    // Buttons processing
    if (values.haveButtons === "yes" && values.buttons) {
      components.push({
        type: "BUTTONS",
        buttons: values.buttons.map((button: any) => ({
          type: button.type,
          text: button.text,
          ...(button.type === "PHONE_NUMBER"
            ? { phone_number: button.phone_number }
            : {}),
          ...(button.type === "URL" ? { url: button.url } : {}),
        })),
      });
    }
  
    // Footer processing
    if (values.footer) {
      components.push({ type: "FOOTER", text: values.footer });
    }
  
    // Debug final components before sending
    logger.log('🚀 Final template data:', {
      components,
      mapper,
      headerMapper,
      name: values.name.toLowerCase(),
      hasBodyComponent: components.some(c => c.type === 'BODY')
    });

    // Construct base data object
    const data: any = {
      name: values.name.toLowerCase(),
      language: values.language,
      category: values.category,
      components,
      mapper,
      headerMapper,
    };
  
    // Add filePaths if present
    if (filePath?.length) {
      data.filePaths = filePath;
    }
  
    // Only include allowCategoryChange for new template creation
    if (!editTemplateData) {
      data.allowCategoryChange = values.allowCategoryChange === "yes";
    }
  
    // Make API call based on whether we're editing or creating
    if (editTemplateData) {
      return await updateTemplate(editTemplateData._id, data);
    }
  
    return await createTemplate(data);
  };

  // Check if template can be edited based on Facebook's rules
  const canEditTemplate = editTemplateData?.status && ["APPROVED", "REJECTED", "PAUSED"].includes(editTemplateData.status);
  const canEditCategory = !editTemplateData || (editTemplateData?.status && ["REJECTED", "PAUSED"].includes(editTemplateData.status)); // Allow for new templates, or REJECTED/PAUSED templates
  const isPendingReview = editTemplateData?.status === "PENDING";

  logger.log('Template Status:', editTemplateData?.status, 'Can Edit Template:', canEditTemplate, 'Can Edit Category:', canEditCategory, 'Is Pending:', isPendingReview);

  const initialValues = useMemo(() => {
    logger.log('initialValues memoization triggered, editTemplateData:', editTemplateData);
    if (editTemplateData) {
      const header = editTemplateData?.components.find(
        (c: any) => c.type === "HEADER"
      );
      const body = editTemplateData?.components.find(
        (c: any) => c.type === "BODY"
      );
      const footer = editTemplateData?.components.find(
        (c: any) => c.type === "FOOTER"
      );
      const buttons = editTemplateData?.components.find(
        (c: any) => c.type === "BUTTONS"
      );
      
      const headerValue = header?.text ? convertNumberedToNamedVariables(header.text, editTemplateData.headerMapper || {}) : "";
      logger.log('Initial header_value:', headerValue);

      return {
        name: editTemplateData.name,
        category: editTemplateData.category,
        language: editTemplateData.language,
        allowCategoryChange: editTemplateData.allowCategoryChange ? "yes" : "no",
        header: header ? header.format.toLowerCase() : "none",
        header_value: headerValue,
        haveButtons: buttons ? "yes" : "no",
        footer: footer?.text || "", // Use existing footer text if editing
        body: body?.text ? convertNumberedToNamedVariables(body.text, editTemplateData.mapper || {}) : "",
        buttons: buttons?.buttons || [{ ...defaultButton }],
      };
    }
    return {
      name: "",
      category: "",
      language: "en",
      allowCategoryChange: "yes",
      header: "none",
      haveButtons: "no",
      footer: "Reply 'STOP' to unsubscribe", // Default footer text for new templates
      body: "",
      header_value: "",
      buttons: Array(3).fill(null).map(() => ({ ...defaultButton })),
    };
  }, [editTemplateData]);

  const isURL = (str: string) => {
    const urlRegex =
      /(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?\/[a-zA-Z0-9]{2,}|((https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z]{2,}(\.[a-zA-Z]{2,})(\.[a-zA-Z]{2,})?)|(https:\/\/www\.|http:\/\/www\.|https:\/\/|http:\/\/)?[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}\.[a-zA-Z0-9]{2,}(\.[a-zA-Z0-9]{2,})?/g;
    return urlRegex.test(str);
  };

  return (
    <Spin size="large" tip="Loading..." spinning={isSubmitting}>
      <div id="main" className="main">
        <Header />
        <Formik
          enableReinitialize
          innerRef={formikRef}
          initialValues={initialValues}
          validateOnChange={isError}
          validate={(values) => {
            const formikErrors: any = {};
            if (!values.name) {
              formikErrors["name"] = `Template name is required`;
            }
            if (!values.allowCategoryChange) {
              formikErrors["allowCategoryChange"] = `Please select`;
            }
            if (!values.language) {
              formikErrors["language"] = `Please select language`;
            }
            if (!values.category) {
              formikErrors["category"] = `Please select category`;
            }
            if (!values.header) {
              formikErrors["header"] = `Required`;
            }
            if (!bodyValue.trim()) {
              formikErrors["body"] = `Required`;
            }

            // Validate dynamic fields in header
            if (values.header === "text" && values.header_value) {
              const headerDynamicFields = values.header_value.match(/{{(.*?)}}/g)
                ?.map((field: string) => field.replace(/{{|}}/g, "")) || [];
              const allowedFields = teamMembers.map((member: TeamMember) => member.value);
              const invalidHeaderFields = headerDynamicFields.filter(
                (field: string) => !allowedFields.includes(field)
              );
              if (invalidHeaderFields.length > 0) {
                formikErrors["header_value"] = `Invalid personalization fields: ${invalidHeaderFields.join(', ')}. Please remove them and use the "Insert lead field" button to add valid fields.`;
              }
            }

            // Validate dynamic fields in body
            if (bodyValue) {
              const bodyDynamicFields = bodyValue.match(/{{(.*?)}}/g)
                ?.map((field: string) => field.replace(/{{|}}/g, "")) || [];
              const allowedFields = teamMembers.map((member: TeamMember) => member.value);
              const invalidBodyFields = bodyDynamicFields.filter(
                (field: string) => !allowedFields.includes(field)
              );
              if (invalidBodyFields.length > 0) {
                formikErrors["body"] = `Invalid personalization fields: ${invalidBodyFields.join(', ')}. Please remove them and use the "Insert lead field" button to add valid fields.`;
              }
            }

            if (values.haveButtons === "yes") {
              if (!Array.isArray(values.buttons)) {
                formikErrors.buttons = "Invalid button structure";
                return formikErrors;
              }
            
            if (values.buttons.length < 1 || values.buttons.length > 5) {  // ← CHANGE 3 to 5
  formikErrors.buttons = "Number of buttons must be between 1 and 5";
  return formikErrors;
}

// ← ADD grouping validation
const groupingResult = validateButtonGrouping(values.buttons);
if (!groupingResult.isValid) {
  formikErrors.buttons = groupingResult.error;
  return formikErrors;
}
            
              values.buttons.forEach((button: typeof defaultButton, index: number) => {
                if (!button || typeof button !== 'object') {
                  formikErrors[`buttons.${index}`] = "Invalid button data";
                  return;
                }
            
                if (!button.type?.trim()) {
                  formikErrors[`buttons.${index}.type`] = "Required";
                }
                if (!button.text?.trim()) {
                  formikErrors[`buttons.${index}.text`] = "Required";
                }
            
                if (button.type === "URL") {
  const url = button.url?.trim() || "";
  if (!url) {
    formikErrors[`buttons.${index}.url`] = "Required";
  } else {
    const normalizedUrl = /^https?:\/\//i.test(url) ? url : `https://${url}`;
    if (!isValidUrl(normalizedUrl)) {
      formikErrors[`buttons.${index}.url`] = "Invalid URL format";
    }
  }
}

if (button.type === "PHONE_NUMBER") {
  if (!button.phone_number?.trim()) {
    formikErrors[`buttons.${index}.phone_number`] = "Required";
  }
}

// ← ADD Quick Reply validation
if (button.type === "QUICK_REPLY") {
  // Quick Reply only needs text validation (already handled above)
  // No additional fields required
}
              });
            }
            return formikErrors;
          }}
          onSubmit={(values) => {
            toggleConfirmEditModal();
            setFormValue({ ...values, body: bodyValue });
          }}
        >
          {({ values, errors, handleChange, handleSubmit }) => {
            const errorsObj: any = JSON.parse(JSON.stringify(errors));

            return (
              <form onSubmit={handleSubmit} className="create_template">
                <section className="auto-section-1 px-0">
                  <div className="d-flex justify-content-between w-100">
                    <div className="align-items-center auto-section-1-sub-1">
                      <button
                        onClick={(e) => {
                          e.preventDefault();
                          toggleEditModal();
                        }}
                      >
                        <i className="fa-regular fa-chevron-left"></i>
                      </button>
                      <h5 className="fw-bold text-dark fm-gilroyBold">
                        Create Template
                      </h5>
                    </div>
                    <button
                      className="btn fw-bold auto_btn w-auto border-0 px-4"
                      type="submit"
                    >
                      Submit for approval
                    </button>
                  </div>
                </section>
                
                {/* Status Indicator */}
                {editTemplateData && editTemplateData.status && (
                  <div className="row mb-4">
                    <div className="col-12">
                      <div className={`alert ${isPendingReview ? 'alert-warning' : editTemplateData.status === 'APPROVED' ? 'alert-success' : 'alert-info'} d-flex align-items-center`}>
                        <i className={`ri-${isPendingReview ? 'time' : editTemplateData.status === 'APPROVED' ? 'file-copy' : 'edit'}-line me-2`}></i>
                        <div>
                          <strong>
                            {isPendingReview
                              ? 'Template Under Review'
                              : editTemplateData.status === 'APPROVED'
                                ? `Creating Translation for "${editTemplateData.name}"`
                                : `Editing ${editTemplateData.status} Template`
                            }
                          </strong>
                          <div className="small">
                            {isPendingReview
                              ? 'This template is pending review and cannot be edited. Please wait for approval/rejection.'
                              : editTemplateData.status === 'APPROVED'
                                ? 'You are creating a translation copy of an approved template. Please change the language to create a new version. You can have multiple language translations for the same template.'
                                : `Editing "${editTemplateData.name}" (${editTemplateData.status}). ${!canEditCategory ? 'Note: Category cannot be changed for APPROVED templates.' : ''}`
                            }
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="row mb-4">
                  <div className="col-md-6">
                    <Inputs
                      disabled={disabled || isPendingReview}
                      name="name"
                      type="text"
                      autoComplete="off"
                      className="form-control py-2 h-45 text-lowercase"
                      placeholder="Enter template name"
                      value={values.name}
                      onChange={(e) => {
                        // Format template name: lowercase, replace spaces/special chars with underscores
                        const formatted = e.target.value
                          .toLowerCase()
                          .replace(/[^a-z0-9_]/g, '_')  // Replace any non-alphanumeric/underscore with underscore
                          .replace(/_+/g, '_');          // Replace multiple consecutive underscores with single

                        // Update the form field with formatted value - keep name attribute!
                        handleSetFieldValue('name', formatted);
                      }}
                      label="Template Name"
                      id=""
                      isRequired
                      options={[]}
                      des="Template name will be automatically formatted (lowercase letters, numbers, and underscores only)"
                    />
                    {errorsObj["name"] && (
                      <ErrorMessage name="name" component={Error} />
                    )}
                  </div>
                </div>
                
      {editTemplateData?.metrics && (
  <div className="row mb-4">
    <div className="col-12">
      <TemplateMetrics metrics={editTemplateData.metrics} />
    </div>
  </div>
)}
                <div className="row mb-4">
                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center justify-content-between">
                      <p className="mb-0">
                        Template Category <span className="text-danger">*</span>
                      </p>
                      <MyToolTip
                        id={`categoryTooltip`}
                        text={`Categories Available:\nAuthentication:For messages related to user verification, such as OTPs or login confirmations.\nMarketing:For promotional messages like discounts, offers, and marketing campaigns.\nUtility:For informational updates, alerts, reminders, and customer support.`}
                      >
                        <i className="lh-normal text-muted fs-5 ri-information-fill me-2"></i>
                      </MyToolTip>
                    </label>
                    <select
                      value={values.category}
                      name="category"
                      onChange={handleChange}
                      className="form-select py-2 h-45"
                      disabled={isPendingReview || !canEditCategory}
                    >
                      <option value="" disabled>
                        Select Category
                      </option>
                      <option value="AUTHENTICATION">Authentication</option>
                      <option value="MARKETING">Marketing</option>
                      <option value="UTILITY">Utility</option>
                    </select>
                    {errorsObj["category"] && (
                      <ErrorMessage name="category" component={Error} />
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      Language <span className="text-danger">*</span>
                    </label>

                    <select
                      value={values.language}
                      name="language"
                      onChange={handleChange}
                      className="form-select py-2 h-45"
                    >
                      <option value="" disabled>
                        Select Language
                      </option>
                      {Object.keys(languageObj || {}).map(
                        (item: string, key: number) => (
                          <option key={key} value={item}>
                            {languageObj &&
                              (languageObj[item as keyof typeof languageObj] ||
                                "")}
                          </option>
                        )
                      )}

                      <option value="en_GB">English(GB)</option>
                    </select>
                    {errorsObj["language"] && (
                      <ErrorMessage name="language" component={Error} />
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label d-flex align-items-center justify-content-between">
                      <p className="mb-0">
                        Allow category change{" "}
                        <span className="text-danger">*</span>
                      </p>
                      <MyToolTip
                        id={`AllowcategoryTooltip`}
                        text={
                          "Enable this option to allow the WhatsApp team to auto-change the category of the template if they determine that your message better fits another category. This increases the chances of template approval by ensuring it aligns with WhatsApp’s policies."
                        }
                      >
                        <i className="lh-normal text-muted fs-5 ri-information-fill me-2"></i>
                      </MyToolTip>
                    </label>
                    <select
                      value={values.allowCategoryChange}
                      name="allowCategoryChange"
                      onChange={handleChange}
                      className="form-select py-2 h-45"
                    >
                      <option value="" disabled>
                        Select
                      </option>
                      <option value="yes">Yes</option>
                      <option value="no">No</option>
                    </select>
                    {errorsObj["allowCategoryChange"] && (
                      <Error>{errorsObj["allowCategoryChange"]}</Error>
                    )}
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-8">
                    {/* Header Section */}
                    <HeaderSection
                      expandedSections={expandedSections}
                      toggleSection={toggleSection}
                      values={values}
                      handleChange={handleChange}
                      setFile={setFile}
                      errorsObj={errorsObj}
                      fileName={fileName}
                      handleFileChange={handleFileChange}
                      file={file}
                      isSubmitting={isSubmitting || isPendingReview}
                    />

                    <BodySection
                      expandedSections={expandedSections}
                      toggleSection={toggleSection}
                      bodyValue={bodyValue}
                      setBodyValue={setBodyValue}
                      values={values}
                      errorsObj={errorsObj}
                      handleChange={handleChange}
                    />

                    <ButtonSection
                      toggleSection={toggleSection}
                      values={values}
                      errorsObj={errorsObj}
                      handleChange={handleChange}
                      expandedSections={expandedSections}
                      setFieldValue={handleSetFieldValue}
                      isSubmitting={isSubmitting}
                    />
                  </div>
                  <div className="col-md-4">
                    <WhatsAppPreview
                      bodyValue={bodyValue}
                      values={values}
                      file={file}
                    />
                  </div>
                </div>
              </form>
            );
          }}
        </Formik>
        <DrawerExistModal
          showExitModal={showExitModal}
          title="Are you sure you want to exit ?"
          toggleEditModal={toggleEditModal}
          handleDrawerClick={handleDrawerClick}
        />
        <DrawerExistModal
          title="Are you sure you want submit?"
          showExitModal={confirmShowExitModal}
          toggleEditModal={toggleConfirmEditModal}
          handleDrawerClick={handleConfirmDrawerClick}
        />
      </div>
    </Spin>
  );
};
export default CreateTemplate;

export const Error = styled.p`
  color: red;
  margin-left: 4px;
  margin-top: 4px;
  font-size: 12px;
`;
